function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*------------------------------------------------------------------
Scroll Control Class
------------------------------------------------------------------*/
var ScrollControl = /*#__PURE__*/function () {
  function ScrollControl() {
    _classCallCheck(this, ScrollControl);
    // This will control the scrolling animations
    this.Controller = new TweenController();
    // The controller's active state
    this.active = false;
    // Initialise the Controller
    this.init();
  }
  _createClass(ScrollControl, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Control the active states
      this.Controller.on('start', function () {
        return _this.active = true;
      });
      this.Controller.on('stop', function () {
        return _this.active = false;
      });
      this.Controller.on('end', function () {
        return _this.active = false;
      });

      // When we scroll the mouse wheel, we want to stop the tween!
      Meteora.attach(window, 'wheel touchstart', function () {
        if (_this.active) _this.Controller.stop();
      });
    }
  }, {
    key: "scrollTo",
    value: function scrollTo() {
      var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      // Work out if we are trying to scroll further than the bottom of the page
      var to = y + window.innerHeight >= document.body.clientHeight ? document.body.clientHeight - window.innerHeight : y;
      // Tell the controller to scroll the window from it's current position to the new y position
      this.Controller.tween({
        from: window.pageYOffset,
        to: to
      }, function (value) {
        return window.scrollTo(0, value);
      }, duration);
    }
  }]);
  return ScrollControl;
}();
export { ScrollControl as default };